import openSaveDB from "./openSaveDB";

import { jsdos_save_store_name } from "./constants";

export default async function () {
  const db = await openSaveDB();
  await db.clear(jsdos_save_store_name);
  db.close();
}
